<template>
  <div class="d-flex flex-column align-items-center pt-2 mt-2">
    <div class="image-wrapper">
      <img src="/imgs/sorry.svg" alt="sorry" />
    </div>
    <h1>404</h1>
    <div>ページが見つかりません</div>
  </div>
</template>

<style lang="scss" scoped>
.image-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 424px;

  img {
    width: 220px;
  }
}
</style>
